<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";

export default {
  mixins: [Api, Sabit],
  page: {
    title: "eCampus Personel Senkron",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "eCampus Personel Senkron",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Sistem Yönetimi",
          href: "/",
        },
        {
          text: "eCampus Personel Senkron",
          active: true,
        },
      ],
      Saatler: Array.from({ length: 24 }, (_, i) => i),
      Ayarlar: {
        Aktif: false,
        Senkronsaat: 3,
        Soncalismatarihi: null,
        Sonsonuc: null,
      },
      calisiyor: false,
      loading: true,
    };
  },

  methods: {
    Get() {
      this.ActionsGet({
        Service: "oecampussenkron",
        FullData: true,
      }).then((res) => {
        if (res && res.Data) {
          this.Ayarlar = res.Data;
        }
        this.loading = false;
      });
    },
    Kaydet() {
      this.UpdateIdsiz(
        "oecampussenkron",
        { Aktif: this.Ayarlar.Aktif, Senkronsaat: this.Ayarlar.Senkronsaat },
        "Ayarlar güncellendi"
      );
    },
    SimdiCalistir() {
      this.calisiyor = true;
      this.Post2("oecampussenkron/tetikle", {}).then(() => {
        this.calisiyor = false;
      });
    },
  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Otomatik Senkronizasyon Ayarları</h5>

              <div class="form-check form-switch mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="ecampusSenkronAktif"
                  v-model="Ayarlar.Aktif"
                />
                <label class="form-check-label" for="ecampusSenkronAktif">
                  Otomatik senkronizasyon aktif
                </label>
              </div>

              <div class="mb-3">
                <label class="form-label" for="ecampusSenkronSaat">
                  Çalışma Saati
                </label>
                <select
                  id="ecampusSenkronSaat"
                  class="form-select"
                  v-model.number="Ayarlar.Senkronsaat"
                >
                  <option v-for="saat in Saatler" :key="saat" :value="saat">
                    {{ String(saat).padStart(2, "0") }}:00
                  </option>
                </select>
                <div class="form-text">
                  Aktif ise, personel senkronu her gün bu saatte otomatik çalışır.
                </div>
              </div>

              <button type="button" class="btn btn-primary" @click="Kaydet">
                <i class="mdi mdi-content-save me-1"></i>
                Kaydet
              </button>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Elle Tetikle</h5>

              <p class="text-muted">
                eCampus API'sinden personel listesini şimdi çeker; sistemde
                eksik olan personelleri ve gerektiğinde birimleri ekler,
                mevcut kayıtlara dokunmaz.
              </p>

              <button
                type="button"
                class="btn btn-success mb-3"
                :disabled="calisiyor"
                @click="SimdiCalistir"
              >
                <span v-if="calisiyor">
                  <i class="mdi mdi-loading mdi-spin me-1"></i>
                  Senkronize ediliyor...
                </span>
                <span v-else>
                  <i class="mdi mdi-sync me-1"></i>
                  Şimdi Senkronize Et
                </span>
              </button>

              <table class="table table-sm mb-0">
                <tbody>
                  <tr>
                    <th style="width: 40%">Son Çalışma Zamanı</th>
                    <td>
                      {{
                        Ayarlar.Soncalismatarihi
                          ? formatDateTableTime(Ayarlar.Soncalismatarihi)
                          : "-"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th>Son Sonuç</th>
                    <td>{{ Ayarlar.Sonsonuc || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
